module.exports = __webpack_public_path__ + "static/media/deliveroo.241339bc.png";